export const pricing = {
  pageHeader: {
    title: 'Votre commission',
  },
  pricingFeatures: {
    group1: {
      feature1: {
        label: 'Établir des factures, des devis, des notes de crédit, …',
      },
      feature2: {
        label: 'Des droits d’auteur 100 % corrects',
      },
      feature3: {
        label: 'Un tableau de bord clair',
      },
      feature4: {
        label: 'Une Community sur laquelle compter',
      },
      title: 'Une plateforme de facturation pratique',
    },
    group2: {
      feature1: {
        label: 'Versement du précompte mobilier',
      },
      feature2: {
        label: 'Établissement de la fiche fiscale',
      },
      feature3: {
        label: 'Rédaction de contrats',
      },
      feature4: {
        label: 'Suivi des paiements',
      },
      title: 'Nous nous occupons de l’administration',
    },
    group3: {
      feature1: {
        label: 'Pas de chatbots, mais des humains',
      },
      feature2: {
        label: 'Double vérification de vos factures',
      },
      feature3: {
        label: 'Aide technique',
      },
      feature4: {
        label: 'Des conseils en langage clair',
      },
      title: 'Une aide personnelle',
    },
    title: 'Ce que vous recevez de nous',
  },
  pricingInfo: {
    commission: {
      details: {
        button: 'Détails',
        commissionWithDiscount: 'Nouvelle commission',
        commissionWithoutDiscount: 'Commission standard',
        freeTrial_one: '{{count}} jour gratuit',
        freeTrial_other: '{{count}} jours gratuits',
        referralDiscount: 'Parrainage {{inviteeName}}',
      },
      deviations: {
        adminOverride: {
          explanation: 'Votre commission diffère du tarif standard.',
          label: 'Commission adaptée',
        },
        earlyAdopter: {
          label: 'Early adopter',
        },
        loyalUser: {
          label: 'Membre fidèle',
          tooltip:
            'Vous êtes avec nous depuis un moment déjà, c’est pourquoi nous vous remercions avec une commission plus basse. Les nouveaux membres qui nous ont rejoints depuis 2025 paient en effet une commission fixe de 8 %.',
        },
        premiumForFree: {
          label_one: 'Encore {{count}} jour gratuit',
          label_other: 'Encore {{count}} jours gratuits',
          tooltip: 'Valable jusqu’au {{expirationDate}} inclus',
        },
        referralDiscount: {
          label: 'Réduction de parrainage ({{amount}})',
        },
        yearlyCopyrightLimitExceeded: {
          explanation:
            'Vous avez dépassé votre plafond de droits d’auteur pour cette année. Toutes vos prestations sont désormais des revenus professionnels, vous pouvez donc facturer gratuitement jusqu’à la fin de l’année.',
          label: 'Plafond de droits d’auteur atteint',
        },
      },
      explanation: {
        subTitle: 'Une commission uniquement quand vous facturez.',
        text: 'C’est ce que Creative Shelter retient sur le montant total de votre facture (hors TVA), par prestation créative. Vous ne payez que lorsque vous facturez. Pas de facture ? Pas de frais.',
        title: 'Pas d’abonnement.',
      },
      title: 'Commission par facture',
    },
  },
  pricingStats: {
    currentYear: {
      text: 'Avantage grâce à Creative Shelter',
      title: 'Avantage en {{year}}',
    },
    error: {
      title: 'Aucune donnée trouvée',
    },
    previousYear: {
      text: 'Avantage total grâce à Creative Shelter',
      title: 'Avantage total en {{year}}',
    },
  },
};
